import { render, staticRenderFns } from "./CreateDotsForm.vue?vue&type=template&id=cfb194a4&scoped=true"
import script from "./CreateDotsForm.vue?vue&type=script&lang=js"
export * from "./CreateDotsForm.vue?vue&type=script&lang=js"
import style0 from "./CreateDotsForm.vue?vue&type=style&index=0&id=cfb194a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb194a4",
  null
  
)

export default component.exports